var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(-0.224 -0.224)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9127",
    "data-name": "Group 9127",
    transform: "translate(-352.727 -543.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    transform: "translate(352.727 543.727)",
    fill: "#fff",
    stroke: "#2c2b34",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(354.951 545.951)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_person_6124340_000000",
    d: "M46.732,40.482A9.984,9.984,0,0,0,36.748,30.5H22.484A9.984,9.984,0,0,0,12.5,40.482v2.853a2.852,2.852,0,0,0,2.853,2.853H43.88a2.852,2.852,0,0,0,2.853-2.853ZM43.88,43.335H15.353V40.482a7.132,7.132,0,0,1,7.132-7.132H36.748a7.132,7.132,0,0,1,7.132,7.132ZM29.616,6.25a10.7,10.7,0,1,0,10.7,10.7,10.7,10.7,0,0,0-10.7-10.7Zm0,2.853a7.845,7.845,0,1,1-7.845,7.845A7.848,7.848,0,0,1,29.616,9.1Z",
    transform: "translate(-6.341 3.228)",
    fill: "#2c2b34",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormUser);
export default __webpack_public_path__ + "static/media/form_user.86325e27e651dd9b78c168ac88bf57f4.svg";
export { ForwardRef as ReactComponent };